/**
 * ActiveObjectProvider — thin context wrapper around the Zustand active-object store.
 *
 * Consumers that live deep in the React tree can call useActiveObject() without
 * manually importing the store. Direct store access via useActiveObjectStore is
 * also fine for components outside the React tree (e.g. WebSocket handlers).
 *
 * State shape:
 *   { activeProjectId, activeFolderId, activeStyleId, activeBomId,
 *     activeThreadId, activeUserRole }
 *
 * Compound actions:
 *   openFolder(folderId, styleId)       → folder click
 *   openTechPack(bomId, threadId)       → Tech Pack open
 *
 * Persistence: activeProjectId only, via localStorage key "lanfinitas-active-project".
 */

import { type ReactNode } from "react";
import { useActiveObjectStore, type ActiveObjectState } from "../stores/active_object_store.js";

export type { ActiveObjectState };
export { useActiveObjectStore };

export function useActiveObject(): ActiveObjectState {
  return useActiveObjectStore();
}

export function ActiveObjectProvider({ children }: { children: ReactNode }) {
  // Store is module-level (Zustand); no React context needed.
  return <>{children}</>;
}
